import React, { useState } from 'react';
import { FaDollarSign } from 'react-icons/fa'; // Icon for balance card
import '../styles/staking.css';
import { useNavigate } from "react-router-dom";

function Staking() {
    const navigate = useNavigate();
    const [balances] = useState([
        { icon: <FaDollarSign />, currency: 'US Dollar oanda', amount: '$970,888.00', duration: '05/03/2025 01:03' },
    ]);

    const [stakes] = useState([
        { status: 'pending', profit: '+1005', interest: '0.5%', startTime: '18 minutes ago', endTime: '06/03/2025 00:18' },
        { status: 'pending', profit: '+1005', interest: '0.5%', startTime: '17 minutes ago', endTime: '06/03/2025 00:46' },
    ]);

    return (
        <div className="staking-page">
            <div className="balance-card">
                {balances.map((balance, index) => (
                    <div key={index} className="balance-row">
                        <span className="balance-icon">{balance.icon}</span>
                        <div className="balance-currency">{balance.currency}</div>
                        <div className="balance-amount">{balance.amount}<br /><span className="balance-label">Available Balance</span></div>
                        <div className="balance-duration">{balance.duration}<br /><span className="duration-label">Duration</span></div>
                    </div>
                ))}
            </div>

            <div className="staking-button">

                <button className="create-staking-button" onClick={() => navigate('/create')}>CREATE STAKING</button>

            </div>
            <div className="staking-section">

                <table className="staking-table">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Profit</th>
                            <th>Interest</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stakes.map((stake, index) => (
                            <tr key={index}>
                                <td>{stake.status}</td>
                                <td>{stake.profit}</td>
                                <td>{stake.interest}</td>
                                <td>{stake.startTime}</td>
                                <td>{stake.endTime}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Staking;